import goto from '@/common/goto';
import { remainingDayHourMinute } from '@/common/utils';
import { Button } from 'antd';
import { enhancedFormateTimeStamp } from '@/common/utils';
import moment from 'moment';
import { applyLog } from '@/pages/all-about-me/components/signed-activity/log.js';

// 详情log
function goDetailLog(id: string) {
  applyLog(id, 1);
}
function goApplyLog(id: string) {
  applyLog(id, 0);
}

{
  /**
   * remark: 类型备注描述
   * type: 卡片类型，对应后端cardActivityType
   * getStatus: (params: any) => (卡片不同状态下的参数
   */
}
type cardTypes = Array<{ remark: string; type: number; getStatus?: any; getCardActTime: (params: any) => string }>;

const timeRender = (time: number, maxTime?: number) => {
  let text = remainingDayHourMinute(time);
  if (maxTime) {
    text = time > maxTime ? '长期可报名' : remainingDayHourMinute(time);
  }
  return <span style={{ color: 'red' }}>{text}</span>;
};
// 不可报名文案
const canNotSignTimeInfo = (time: number) => (time ? '暂不可报名' : '报名已截止');
// 距报名开始还剩文案
const ordinaryBeforeSignTimeInfo = (time: number) => <>距报名开始还剩: {timeRender(time)}</>;
// 距报名还剩文案
const ordinaryNotSignTimeInfo = (time: number) => (
  //超过100天 则转换为固定文案展示，固定文案为“长期可报名”。
  <>报名还剩: {timeRender(time, 100 * 24 * 60 * 60 * 1000)}</>
);
// 立即报名
const ToSingBtn = (props: any) => <Button type="primary" ghost {...props} />;
// 活动时间范围
const ordinaryActivityTimeRange = (params: any) =>
  `${
    params.pendingActivityBeginTime ||
    enhancedFormateTimeStamp(moment(params.cardBeginTime).valueOf(), 'YY-MM-DD hh:mm')
  } 至 ${
    params.pendingActivityEndTime || enhancedFormateTimeStamp(moment(params.cardEndTime).valueOf(), 'YY-MM-DD hh:mm')
  }`;

const cardActivityTypes: cardTypes = [
  {
    remark: '主题活动-招商报名',
    type: 10,
    getCardActTime: ordinaryActivityTimeRange,
    getStatus: (params: any) => ({
      beforeSign: {
        timeInfo: ordinaryBeforeSignTimeInfo,
        button: (
          <Button
            disabled={!params.planCode}
            onClick={() => {
              goDetailLog(params.cardId);
              goto.merchantActivityMyWare(params.planCode).newTab();
            }}
          >
            查看详情
          </Button>
        ),
      },
      notSign: {
        timeInfo: ordinaryNotSignTimeInfo,
        button: (
          <ToSingBtn
            disabled={!params.planCode}
            onClick={() => {
              goApplyLog(params.cardId);
              goto.merchantActivityMyWare(params.planCode).newTab();
            }}
          >
            立即报名
          </ToSingBtn>
        ),
      },
      signed: {
        timeInfo: ordinaryNotSignTimeInfo,
        button: (
          <ToSingBtn
            disabled={!params.planCode}
            onClick={() => {
              goApplyLog(params.cardId);
              goto.merchantActivityMyWare(params.planCode).newTab();
            }}
          >
            报过，继续报名
          </ToSingBtn>
        ),
      },
      endSign: {
        timeInfo: canNotSignTimeInfo,
        button: (
          <Button
            disabled={!params.planCode}
            onClick={() => {
              goDetailLog(params.cardId);
              goto.merchantActivityMyWare(params.planCode).newTab();
            }}
          >
            查看详情
          </Button>
        ),
      },
    }),
  },
  {
    remark: '主题活动/素材维护',
    type: 11,
    getCardActTime: ordinaryActivityTimeRange,
    getStatus: (params: any) => ({
      beforeSign: {
        timeInfo: ordinaryBeforeSignTimeInfo,
        button: (
          <Button
            disabled={!params.planCode}
            onClick={() => {
              goDetailLog(params.cardId);
              goto.merchantActivityMyWare(params.planCode, 5).newTab();
            }}
          >
            查看详情
          </Button>
        ),
      },
      notSign: {
        timeInfo: (time: number) => <>还剩: {timeRender(time)}</>,
        button: (
          <ToSingBtn
            disabled={!params.planCode}
            onClick={() => goto.merchantActivityMyWare(params.planCode, 5).newTab()}
          >
            立即前往
          </ToSingBtn>
        ),
      },
      signed: {
        timeInfo: () => '活动结束前可持续完善',
        button: (
          <ToSingBtn
            disabled={!params.planCode}
            onClick={() => goto.merchantActivityMyWare(params.planCode, 5).newTab()}
          >
            继续完善
          </ToSingBtn>
        ),
      },
      endSign: {
        timeInfo: canNotSignTimeInfo,
        button: (
          <Button
            disabled={!params.planCode}
            onClick={() => {
              goDetailLog(params.cardId);
              goto.merchantActivityMyWare(params.planCode, 5).newTab();
            }}
          >
            查看详情
          </Button>
        ),
      },
    }),
  },
  {
    remark: '主题-会场活动',
    type: 12,
    getCardActTime: ordinaryActivityTimeRange,
    getStatus: (params: any) => {
      const { planCode, roomId, activityId } = params;
      const flag = planCode && roomId && activityId;
      const _params = { entry: 1, from: 'acore', hideTab: 1, planCode, roomId, activityId };
      return {
        beforeSign: {
          timeInfo: ordinaryBeforeSignTimeInfo,
          button: (
            <Button
              disabled={!flag}
              onClick={() => {
                goDetailLog(params.cardId);
                goto.merchantVenueDetailPoolList(_params).newTab();
              }}
            >
              查看详情
            </Button>
          ),
        },
        notSign: {
          timeInfo: ordinaryNotSignTimeInfo,
          button: (
            <ToSingBtn
              disabled={!flag}
              onClick={() => {
                goApplyLog(params.cardId);
                goto.merchantVenueDetailPoolList(_params).newTab();
              }}
            >
              立即报名
            </ToSingBtn>
          ),
        },
        signed: {
          timeInfo: ordinaryNotSignTimeInfo,
          button: (
            <ToSingBtn
              disabled={!flag}
              onClick={() => {
                goApplyLog(params.cardId);
                goto.merchantVenueDetailPoolList(_params).newTab();
              }}
            >
              报过，继续报名
            </ToSingBtn>
          ),
        },
        endSign: {
          timeInfo: canNotSignTimeInfo,
          button: (
            <Button
              disabled={!flag}
              onClick={() => {
                goDetailLog(params.cardId);
                goto.merchantVenueDetailPoolList(_params).newTab();
              }}
            >
              查看详情
            </Button>
          ),
        },
      };
    },
  },
  {
    remark: '主题-综促活动',
    type: 13,
    getCardActTime: ordinaryActivityTimeRange,
    getStatus: (params: any) => {
      const { umActivityId, planCode } = params;
      const flag = umActivityId && planCode;
      const _params = { tab_key: 1, activity_id: umActivityId, planCode };
      return {
        beforeSign: {
          timeInfo: ordinaryBeforeSignTimeInfo,
          button: (
            <Button
              disabled={!flag}
              onClick={() => {
                goDetailLog(params.cardId);
                goto.merchantPromotionToZongcuSignUp(_params).newTab();
              }}
            >
              查看详情
            </Button>
          ),
        },
        notSign: {
          timeInfo: ordinaryNotSignTimeInfo,
          button: (
            <ToSingBtn
              disabled={!flag}
              onClick={() => {
                goApplyLog(params.cardId);
                goto.merchantPromotionToZongcuSignUp(_params).newTab();
              }}
            >
              立即报名
            </ToSingBtn>
          ),
        },
        signed: {
          timeInfo: ordinaryNotSignTimeInfo,
          button: (
            <ToSingBtn
              disabled={!flag}
              onClick={() => {
                goApplyLog(params.cardId);
                goto.merchantPromotionToZongcuSignUp(_params).newTab();
              }}
            >
              报过，继续报名
            </ToSingBtn>
          ),
        },
        endSign: {
          timeInfo: canNotSignTimeInfo,
          button: (
            <Button
              disabled={!flag}
              onClick={() => {
                goDetailLog(params.cardId);
                goto.merchantPromotionToZongcuSignUp(_params).newTab();
              }}
            >
              查看详情
            </Button>
          ),
        },
      };
    },
  },
  {
    remark: '平台/频道阵地（预留，真实无此类型）',
    type: 20,
    getCardActTime: ordinaryActivityTimeRange,
    getStatus: (params: any) => ({
      beforeSign: {},
      notSign: {},
      signed: {},
      endSign: {},
    }),
  },
  {
    remark: '阵地-资源位',
    type: 21,
    getCardActTime: () => '长期在线，可持续报名场次',
    getStatus: (params: any) => {
      const { channelType, channelId, resourceId, activityId, hasOpenArea, isGoNewRoomList } = params;
      const flag = channelType && channelId && resourceId && activityId;
      const _params = { entry: 1, hideTab: 1, channelId, resourceId, activityId, id: activityId, autoPosition: 1 };
      const goPlatform =
        hasOpenArea && isGoNewRoomList ? goto.platformMarketingResourceRoomList : goto.platformMarketingResourceSignUp;
      const goChannel =
        hasOpenArea && isGoNewRoomList ? goto.channelResourceSignUpRoomList : goto.channelResourceSignUp;
      const jumpTo = channelType == 3 ? goPlatform : goChannel;
      return {
        beforeSign: {
          timeInfo: ordinaryBeforeSignTimeInfo,
          button: (
            <Button
              disabled={!flag}
              onClick={() => {
                goDetailLog(params.cardId);
                jumpTo(_params).newTab();
              }}
            >
              查看详情
            </Button>
          ),
        },
        notSign: {
          timeInfo: ordinaryNotSignTimeInfo,
          button: (
            <ToSingBtn
              disabled={!flag}
              onClick={() => {
                goApplyLog(params.cardId);
                jumpTo(_params).newTab();
              }}
            >
              立即报名
            </ToSingBtn>
          ),
        },
        signed: {
          timeInfo: ordinaryNotSignTimeInfo,
          button: (
            <ToSingBtn
              disabled={!flag}
              onClick={() => {
                goApplyLog(params.cardId);
                jumpTo(_params).newTab();
              }}
            >
              报过，继续报名
            </ToSingBtn>
          ),
        },
        endSign: {
          timeInfo: canNotSignTimeInfo,
          button: (
            <Button
              disabled={!flag}
              onClick={() => {
                goDetailLog(params.cardId);
                jumpTo(_params).newTab();
              }}
            >
              查看详情
            </Button>
          ),
        },
      };
    },
  },
  {
    remark: '阵地-综促活动',
    type: 22,
    getCardActTime: ordinaryActivityTimeRange,
    getStatus: (params: any) => {
      const { channelType, channelId, umActivityId: activity_id } = params;
      const flag = channelType && channelId && activity_id;
      const _params = { tab_key: 1, channelId, activity_id };
      const jumpTo = channelType == 3 ? goto.platformMarketingZongcuSignUp : goto.channelZongcuSignUp;
      return {
        beforeSign: {
          timeInfo: ordinaryBeforeSignTimeInfo,
          button: (
            <Button
              disabled={!flag}
              onClick={() => {
                goDetailLog(params.cardId);
                jumpTo(_params).newTab();
              }}
            >
              查看详情
            </Button>
          ),
        },
        notSign: {
          timeInfo: ordinaryNotSignTimeInfo,
          button: (
            <ToSingBtn
              disabled={!flag}
              onClick={() => {
                goApplyLog(params.cardId);
                jumpTo(_params).newTab();
              }}
            >
              立即报名
            </ToSingBtn>
          ),
        },
        signed: {
          timeInfo: ordinaryNotSignTimeInfo,
          button: (
            <ToSingBtn
              disabled={!flag}
              onClick={() => {
                goApplyLog(params.cardId);
                jumpTo(_params).newTab();
              }}
            >
              报过，继续报名
            </ToSingBtn>
          ),
        },
        endSign: {
          timeInfo: canNotSignTimeInfo,
          button: (
            <Button
              disabled={!flag}
              onClick={() => {
                goDetailLog(params.cardId);
                jumpTo(_params).newTab();
              }}
            >
              查看详情
            </Button>
          ),
        },
      };
    },
  },
  {
    remark: '阵地-秒杀',
    type: 23,
    getCardActTime: () => '长期在线，可持续报名场次',
    getStatus: (params: any) => ({
      beforeSign: {
        timeInfo: ordinaryBeforeSignTimeInfo,
        button: (
          <Button
            disabled={!params.secKillChannelLinkUrl}
            onClick={() => {
              goDetailLog(params.cardId);
              window.open(params.secKillChannelLinkUrl);
            }}
          >
            查看详情
          </Button>
        ),
      },
      notSign: {
        timeInfo: ordinaryNotSignTimeInfo,
        button: (
          <ToSingBtn
            disabled={!params.secKillCanApplyLinkUrl}
            onClick={() => {
              goApplyLog(params.cardId);
              window.open(params.secKillCanApplyLinkUrl);
            }}
          >
            立即报名
          </ToSingBtn>
        ),
      },
      signed: {
        timeInfo: ordinaryNotSignTimeInfo,
        button: (
          <ToSingBtn
            disabled={!params.secKillCanApplyLinkUrl}
            onClick={() => {
              goApplyLog(params.cardId);
              window.open(params.secKillCanApplyLinkUrl);
            }}
          >
            报过，继续报名
          </ToSingBtn>
        ),
      },
      endSign: {
        timeInfo: canNotSignTimeInfo,
        button: (
          <Button
            disabled={!params.secKillAppliedLinkUrl}
            onClick={() => {
              goDetailLog(params.cardId);
              window.open(params.secKillAppliedLinkUrl);
            }}
          >
            查看详情
          </Button>
        ),
      },
    }),
  },
  {
    remark: '阵地-闪购',
    type: 24,
    getCardActTime: () => '长期在线，可持续报名场次',
    getStatus: (params: any) => ({
      beforeSign: {
        timeInfo: ordinaryBeforeSignTimeInfo,
        button: (
          <Button
            disabled={!params.secKillChannelLinkUrl}
            onClick={() => {
              goDetailLog(params.cardId);
              window.open(params.secKillChannelLinkUrl);
            }}
          >
            查看详情
          </Button>
        ),
      },
      notSign: {
        timeInfo: ordinaryNotSignTimeInfo,
        button: (
          <ToSingBtn
            disabled={!params.secKillCanApplyLinkUrl}
            onClick={() => {
              goApplyLog(params.cardId);
              window.open(params.secKillCanApplyLinkUrl);
            }}
          >
            立即报名
          </ToSingBtn>
        ),
      },
      signed: {
        timeInfo: ordinaryNotSignTimeInfo,
        button: (
          <ToSingBtn
            disabled={!params.secKillCanApplyLinkUrl}
            onClick={() => {
              goApplyLog(params.cardId);
              window.open(params.secKillCanApplyLinkUrl);
            }}
          >
            报过，继续报名
          </ToSingBtn>
        ),
      },
      endSign: {
        timeInfo: canNotSignTimeInfo,
        button: (
          <Button
            disabled={!params.secKillAppliedLinkUrl}
            onClick={() => {
              goDetailLog(params.cardId);
              window.open(params.secKillAppliedLinkUrl);
            }}
          >
            查看详情
          </Button>
        ),
      },
    }),
  },
  {
    remark: '日常活动-盘货',
    type: 30,
    getCardActTime: ordinaryActivityTimeRange,
    getStatus: (params: any) => {
      const { activityId: id } = params;
      return {
        beforeSign: {
          timeInfo: ordinaryBeforeSignTimeInfo,
          button: (
            <Button
              disabled={!id}
              onClick={() => {
                goDetailLog(params.cardId);
                goto.myCreatePhSignUp({ id }).newTab();
              }}
            >
              查看详情
            </Button>
          ),
        },
        notSign: {
          timeInfo: ordinaryNotSignTimeInfo,
          button: (
            <ToSingBtn
              disabled={!id}
              onClick={() => {
                goApplyLog(params.cardId);
                goto.myCreatePhSignUp({ id }).newTab();
              }}
            >
              立即报名
            </ToSingBtn>
          ),
        },
        signed: {
          timeInfo: ordinaryNotSignTimeInfo,
          button: (
            <ToSingBtn
              disabled={!id}
              onClick={() => {
                goApplyLog(params.cardId);
                goto.myCreatePhSignUp({ id }).newTab();
              }}
            >
              报过，继续报名
            </ToSingBtn>
          ),
        },
        endSign: {
          timeInfo: canNotSignTimeInfo,
          button: (
            <Button
              disabled={!id}
              onClick={() => {
                goDetailLog(params.cardId);
                goto.myCreatePhSignUp({ id }).newTab();
              }}
            >
              查看详情
            </Button>
          ),
        },
      };
    },
  },
  {
    remark: '日常活动-会场',
    type: 31,
    getCardActTime: ordinaryActivityTimeRange,
    getStatus: (params: any) => {
      const { activityId } = params;
      const _params = { entry: 1, from: 'acore', hideTab: 1, activityId, id: activityId };
      return {
        beforeSign: {
          timeInfo: ordinaryBeforeSignTimeInfo,
          button: (
            <Button
              disabled={!activityId}
              onClick={() => {
                goDetailLog(params.cardId);
                goto.myCreateActivityReceiptRoomList(_params).newTab();
              }}
            >
              查看详情
            </Button>
          ),
        },
        notSign: {
          timeInfo: ordinaryNotSignTimeInfo,
          button: (
            <ToSingBtn
              disabled={!activityId}
              onClick={() => {
                goApplyLog(params.cardId);
                goto.myCreateActivityReceiptRoomList(_params).newTab();
              }}
            >
              立即报名
            </ToSingBtn>
          ),
        },
        signed: {
          timeInfo: ordinaryNotSignTimeInfo,
          button: (
            <ToSingBtn
              disabled={!activityId}
              onClick={() => {
                goApplyLog(params.cardId);
                goto.myCreateActivityReceiptRoomList(_params).newTab();
              }}
            >
              报过，继续报名
            </ToSingBtn>
          ),
        },
        endSign: {
          timeInfo: canNotSignTimeInfo,
          button: (
            <Button
              disabled={!activityId}
              onClick={() => {
                goDetailLog(params.cardId);
                goto.myCreateActivityReceiptRoomList(_params).newTab();
              }}
            >
              查看详情
            </Button>
          ),
        },
      };
    },
  },
  {
    remark: '日常活动-综促',
    type: 32,
    getCardActTime: ordinaryActivityTimeRange,
    getStatus: (params: any) => {
      const { umActivityId: activity_id } = params;
      return {
        beforeSign: {
          timeInfo: ordinaryBeforeSignTimeInfo,
          button: (
            <Button
              disabled={!activity_id}
              onClick={() => {
                goDetailLog(params.cardId);
                goto.myCreateZongcuActivityReceipt({ activity_id }).newTab();
              }}
            >
              查看详情
            </Button>
          ),
        },
        notSign: {
          timeInfo: ordinaryNotSignTimeInfo,
          button: (
            <ToSingBtn
              disabled={!activity_id}
              onClick={() => {
                goApplyLog(params.cardId);
                goto.myCreateZongcuActivityReceipt({ activity_id }).newTab();
              }}
            >
              立即报名
            </ToSingBtn>
          ),
        },
        signed: {
          timeInfo: ordinaryNotSignTimeInfo,
          button: (
            <ToSingBtn
              disabled={!activity_id}
              onClick={() => {
                goApplyLog(params.cardId);
                goto.myCreateZongcuActivityReceipt({ activity_id }).newTab();
              }}
            >
              报过，继续报名
            </ToSingBtn>
          ),
        },
        endSign: {
          timeInfo: canNotSignTimeInfo,
          button: (
            <Button
              disabled={!activity_id}
              onClick={() => {
                goDetailLog(params.cardId);
                goto.myCreateZongcuActivityReceipt({ activity_id }).newTab();
              }}
            >
              查看详情
            </Button>
          ),
        },
      };
    },
  },
];

const cardActivityTypesMap: any = {};

cardActivityTypes.map((item: any) => {
  cardActivityTypesMap[item.type] = item;
});

export { cardActivityTypes, cardActivityTypesMap };
// 活动类型

// 10、营销中心主题code

// 11、素材维护

// 12、主题-会场活动

// 13、主题-综促活动

// 20、平台/频道阵地（预留，真实无此类型）

// 21、阵地-资源位（会场活动）

// 22、阵地-综促活动（促销策略）

// 30、日常活动-盘货

// 31、日常活动-会场

// 32、日常活动-综促
